import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import * as Converter from "../converter";
import * as Schema from "../schema";

import type * as Type from "../type";

type Props = {
	hotelID: string;
};

type Result = {
	optionPmsColorListQueryData: Type.QueryData.OptionPmsColorListQueryData | undefined;
};

export const useOptionPmsColorListQuery = ({ hotelID }: Props): Result => {
	const { data } = useCustomSuspenseQuery(Schema.OPTION_PMS_COLOR_LIST_FOR_OPTION_PMS, {
		variables: { hotelID },
	});

	const { optionPmsColorListQueryData } = Converter.useOptionPmsColorListConverter({
		optionPmsColorListServerData: data,
	});

	return {
		optionPmsColorListQueryData,
	};
};
